import { render } from "./StatusToogleButton.vue?vue&type=template&id=12bce6eb&scoped=true"
import script from "./StatusToogleButton.vue?vue&type=script&lang=js"
export * from "./StatusToogleButton.vue?vue&type=script&lang=js"

import "./StatusToogleButton.vue?vue&type=style&index=0&id=12bce6eb&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12bce6eb"]])

export default __exports__